import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import i18n, { defaultLocale } from '@/i18n'
import moment from 'moment'
// import vuetify from '../plugins/vuetify'

Vue.use(Vuex)

const defaultState = () => {
  return {
    locale: defaultLocale,
    user: null,
    isAuthorized: false
  }
}

export default new Vuex.Store({
  state: defaultState,
  mutations: {
    updateLocale (state, newLocale) {
      // console.log('updateLocale', state, newLocale)
      state.locale = newLocale
    }
  },
  actions: {
    changeLocale ({ commit }, newLocale) {
      // console.log('changeLocale', arguments)
      i18n.locale = newLocale
      moment.locale(newLocale)
      /**
       * Добавление пробела в 10/06/2020 2:25:01 PM: 10/06/2020 2:25:01&nbsp;PM
       */
      moment.updateLocale(newLocale, {
        longDateFormat: {
          LTS: moment.localeData(newLocale).longDateFormat('LTS').toString().replace(' ', '[&nbsp;]')
        }
      })
      /**
       *
       */
      commit('updateLocale', newLocale)
    }
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
